import Dropcursor from '@tiptap/extension-dropcursor';
import Gapcursor from '@tiptap/extension-gapcursor';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import History from '@tiptap/extension-history';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Code from '@tiptap/extension-code';
import CodeBlock from '@tiptap/extension-code-block';
import Heading from '@tiptap/extension-heading';
import HardBreak from '@tiptap/extension-hard-break';
import Strike from '@tiptap/extension-strike';
import Blockquote from '@tiptap/extension-blockquote';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import ListItem from '@tiptap/extension-list-item';

function defaultExtensions(options) {
    return [
        Document,
        Paragraph.configure(options === null || options === void 0 ? void 0 : options.paragraph),
        Text,
        Bold.configure(options === null || options === void 0 ? void 0 : options.bold),
        Italic.configure(options === null || options === void 0 ? void 0 : options.italic),
        Code.configure(options === null || options === void 0 ? void 0 : options.code),
        Strike.configure(options === null || options === void 0 ? void 0 : options.strike),
        HardBreak.configure(options === null || options === void 0 ? void 0 : options.hardBreak),
        Heading.configure(options === null || options === void 0 ? void 0 : options.heading),
        Blockquote.configure(options === null || options === void 0 ? void 0 : options.blockquote),
        BulletList.configure(options === null || options === void 0 ? void 0 : options.bulletList),
        OrderedList.configure(options === null || options === void 0 ? void 0 : options.orderedList),
        ListItem.configure(options === null || options === void 0 ? void 0 : options.listItem),
        HorizontalRule.configure(options === null || options === void 0 ? void 0 : options.horizontalRule),
        CodeBlock.configure(options === null || options === void 0 ? void 0 : options.codeBlock),
        History.configure(options === null || options === void 0 ? void 0 : options.history),
        Dropcursor.configure(options === null || options === void 0 ? void 0 : options.dropcursor),
        Gapcursor,
    ];
}

export { defaultExtensions };
//# sourceMappingURL=tiptap-starter-kit.esm.js.map
